import { render, staticRenderFns } from "./sharetype.vue?vue&type=template&id=98a47dda&scoped=true&"
import script from "./sharetype.vue?vue&type=script&lang=js&"
export * from "./sharetype.vue?vue&type=script&lang=js&"
import style0 from "./sharetype.vue?vue&type=style&index=0&id=98a47dda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a47dda",
  null
  
)

export default component.exports